import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { ExaminationForm } from '@pixacare/domain';
import { ExaminationFormResponse } from '@pixacare/dtos';
import { TuiAppearance, TuiCell, TuiDialogContext, TuiIcon, TuiTitle } from '@taiga-ui/core';
import { TuiSurface } from '@taiga-ui/layout';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';

type I = {
  text?: string;
  examinationForms: ExaminationFormResponse[];
};

@Component({
  selector: 'pxc-examination-select-dialog',
  imports: [EmptyStateComponent, TuiAppearance, TuiCell, TuiIcon, TuiTitle, TuiSurface, TranslocoDirective],
  templateUrl: './examination-select-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExaminationSelectDialogComponent {
  readonly context = inject<TuiDialogContext<ExaminationForm, I>>(POLYMORPHEUS_CONTEXT);
  private readonly translocoService = inject(TranslocoService);

  readonly text = this.context.data.text ?? this.translocoService.translate('Sélectionner un examen');
  readonly examinationForms = this.context.data.examinationForms ?? [];

  select(examinationForm: ExaminationForm): void {
    this.context.completeWith(examinationForm);
  }
}
